import { cancelCandidacy, getFriend, removeCandidacy, toConfirm } from '../../api'
import {
  CANDIDACY_ERR,
  CANDIDACY_REMOVE,
  GET_ACCEPT_CANDIDACY,
  GET_ALL_PARTENAIRE,
} from '../constants'

export const acceptAction = (id) => async (dispatch) => {
  try {
    const res = await toConfirm(id)
    dispatch({
      type: GET_ACCEPT_CANDIDACY,
      payload: id,
    })
    return res
  } catch (error) {
    const { response } = error
    dispatch({
      type: CANDIDACY_ERR,
      payload: response,
    })
  }
}

export const friends = () => async (dispatch) => {
  try {
    const res = await getFriend()
    dispatch({
      type: GET_ALL_PARTENAIRE,
      payload: res.data,
    })
    return res
  } catch (error) {
    const { response } = error
    dispatch({
      type: CANDIDACY_ERR,
      payload: response,
    })
  }
}

export const cancel = (id) => async (dispatch) => {
  try {
    const res = await cancelCandidacy(id)
    dispatch({
      type: CANDIDACY_REMOVE,
      payload: id,
    })
    return res
  } catch (error) {
    const { response } = error
    dispatch({
      type: CANDIDACY_ERR,
      payload: response,
    })
  }
}

export const removeFriend = (id) => async (dispatch) => {
  try {
    const res = await removeCandidacy(id)
    dispatch({
      type: CANDIDACY_REMOVE,
      payload: id,
    })
    return res
  } catch (error) {
    const { response } = error
    dispatch({
      type: CANDIDACY_ERR,
      payload: response,
    })
  }
}